var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { LiveRegionTestIdFactory } from './interactions';
import { useIsLiveRegionReady } from './useIsLiveRegionReady';
import styles from './LiveRegion.module.css';
export const LiveRegion = ({ children, 'data-testid': testId, isVisuallyHidden = true, politeness = 'polite', }) => {
    _react_refresh_temp_2();
    const isReady = useIsLiveRegionReady();
    return (_jsx("div", { className: isVisuallyHidden ? styles.Container : styles.Visible, ...(testId && {
            'data-testid': LiveRegionTestIdFactory.getLiveRegionTestId(testId),
        }), role: politeness === 'assertive' ? 'alert' : 'status', children: isReady || !isVisuallyHidden ? children : null }));
};
_react_refresh_temp_1 = LiveRegion;
$RefreshReg$(_react_refresh_temp_1, "LiveRegion");
_react_refresh_temp_2(LiveRegion, "MQ9CU32nxJFpe38WkplpbjAIWTQ=", false, () => [useIsLiveRegionReady]);
